import axios from 'axios';

export const requestSessionExtending = async (token) => {
	const { data } = await axios.patch(
		`${import.meta.env.VITE_API_HOST}/api/v1/auth/sessions/extend`,
		undefined,
		{
			headers: {
				Authorization: token,
			},
		},
	);

	return data;
};
